import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const DOWNLOAD_CHARTS = 'download charts'
export const DOWNLOAD_TABLE = 'download table'
export const DOWNLOAD_CHART = 'download-chart'
export const WORD_CLOUD = 'word-cloud'

export default {
  [PORTUGUESE]: {
    [DOWNLOAD_CHARTS]: 'Baixar Gráficos',
    [DOWNLOAD_TABLE]: 'Baixar Tabelas',
    [DOWNLOAD_CHART]: 'Baixar Gráfico',
    [WORD_CLOUD]: 'Baixar Nuvem de Palavras',
  },

  [ENGLISH]: {
    [DOWNLOAD_CHARTS]: 'Download Charts',
    [DOWNLOAD_TABLE]: 'Download Tables',
    [DOWNLOAD_CHART]: 'Download Chart',
    [WORD_CLOUD]: 'Download Word Cloud',
  },

  [SPANISH]: {
    [DOWNLOAD_CHARTS]: 'Descargar Gráficos',
    [DOWNLOAD_TABLE]: 'Descargar Tablas',
    [DOWNLOAD_CHART]: 'Descargar Gráfico',
    [WORD_CLOUD]: 'Descargar Nube de palabras',
  },
}
